import { schema } from 'normalizr';

export const fastenerBomItemSchema = new schema.Entity(
  'fastenerBomItems',
  {},
  {
    idAttribute: (fastenerBomItem) => fastenerBomItem?.product?.id,
  },
);

export const unresolvedFastenerBomItemSchema = new schema.Entity(
  'unresolvedFastenerBomItems',
  {},
  {
    idAttribute: (fastenerBomItem) => fastenerBomItem?.partUuid,
  },
);
